// @ts-strict-ignore
import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  HostBinding,
  Input, OnDestroy,
  OnInit,
  Output,
  ViewContainerRef
} from '@angular/core';
import { LMModel } from '@form/model';
import { LMFormPagingService } from '@form/services/lm-form-paging.service';
import { LMFormService } from '@form/services/lm-form.service';
import { LMFormContentBase } from './lm-form.model';
import { LMFormState } from '@states/models/lm-form-state.model';
import { LMFormPersonalization } from '@states/models/lm-form-personalization.model';
import { LMBusyIndicatorService, LMComponentInfoService, LMLoggerService } from '@services/index';
import { Observable } from 'rxjs';
import { LMInvalidFieldEvent } from '@field/lm-field-base.component';
import { LMFormSpecUtilService } from './services';
import { LMCtrlShiftClickBaseComponent } from '@base/index';
import { LMHtmlUrlDocService } from '@services/lm-html-url-doc.service';
import { LMManualRepresentationComponent } from '@field/manualrepresentation';
import { LMGlobalUtilService } from '@app/utils';
import { LMContextService } from '@services/lm-context.service';
import { LMFormManualRepService } from '@app/components';

@Component({
  selector:    'lm-form-content-form',
  templateUrl: './lm-form-content-form.component.html',
  styleUrls:   [ './lm-form-content-form.component.scss' ],
  providers:   [ LMFormPagingService ]
  })
export class LMFormContentFormComponent extends LMCtrlShiftClickBaseComponent implements LMFormContentBase, OnInit, AfterViewInit, OnDestroy {
  // Set height dynamically. ()
  @HostBinding('style.height') @Input() height = 'auto';

  // DON'T USE full-width class. form .row already has padding on
  // causing 20px on the right side of the form . There is no padding for the
  // top and left. And last component class adds 30px padding to the bottom.
  // top - 30px, right - 10px, bottom - 0px, left - 30px
  // LMCLIENT-28071 - need 20px bottom for context forms
  @HostBinding('style.padding')
  get padding() {
    let bottom = '0';

    if (this.formOptions?.isMultiSelectContent) {
      return null;
    }

    if (this.isTemplateForm) {
      return '0 10px';
    }

    if (this.formSpec.isContextForm) {
      bottom = '20px';
    }

    if (this.formOptions?.isDashBoardContent) {
      if (this.lmFormSpecUtilService.isMenuLayoutForm(this.formSpec)) {
        if (this.lmFormSpecUtilService.isLargeMenuScale(this.formSpec)) {
          return `15px 10px 10px 20px`;
        } else {
          return `15px 10px 10px 10px`;
        }
      }
      return this.lmFormService && !this.lmFormSpecUtilService.isSearchForm(this.formSpec) ? `0 10px 10px 15px` : '';
    }

    // Less padding for mobile (phones)
    if (window.innerWidth <= 610 - 1) {
      return this.lmFormService && !this.lmFormSpecUtilService.isSearchForm(this.formSpec) ? `15px 10px ${bottom} 10px` : '';
    }

    if (this.formOptions?.actionFormDialogData) {
      return null;
    }

    if (!this.lmFormSpecUtilService.isSearchForm(this.formSpec) && this.lmContextService.inMingleOverlay()) {
      if (this.formSpec.busFormSpec) {
        if (this.lmFormSpecUtilService.isActionFormWithSections(this.formSpec)) {
          return `10px 10px ${bottom} 20px !important`;
        }
        return `0 10px ${bottom} 20px !important`;
      }
    }

    return this.lmFormService && !this.lmFormSpecUtilService.isSearchForm(this.formSpec) ? `30px 10px ${bottom} 20px` : '';
  }

  // TODO: formSpec is not always LMFormSpec
  @Input() formSpec: LMFormSpec;
  @Input() formOptions: LMFormOptions = null;
  @Input() isTemplateForm: boolean;

  @Input() specFields: LMSpecFields;
  @Input() layout: LMFormLayout;
  @Input() model: LMModel;
  @Input() formState: LMFormState;
  @Input() placeHolder: ViewContainerRef;
  @Input() formPersonalization: LMFormPersonalization;
  @Input() activatedTabChanged: boolean;
  @Input() hideBusyIndicator: boolean;
  @Input() parentIsModal: boolean;

  @Output() dataViewLoaded: EventEmitter<LMDataView> = new EventEmitter<LMDataView>();
  @Output() fieldEvent: EventEmitter<LMFieldEvent> = new EventEmitter<LMFieldEvent>();

  private instanceId: string;

  constructor(
    public lmComponentInfoService: LMComponentInfoService,
    private lmFormService: LMFormService,
    private lmFormSpecUtilService: LMFormSpecUtilService,
    private lmLoggerService: LMLoggerService,
    private lmBusyIndicatorService: LMBusyIndicatorService,
    public elementRef: ElementRef,
    private lmHtmlUrlDocService: LMHtmlUrlDocService,
    private lmContextService: LMContextService,
    private lmGlobalUtilService: LMGlobalUtilService
  ) {
    super(lmComponentInfoService);
    this.instanceId = this.lmLoggerService.instanceId;
  }

  // events
  onDataViewLoaded(dataView: LMDataView) {
    this.dataViewLoaded.emit(dataView);
  }

  onFieldEvent(event) {
    if ('FieldInvalidEvent' === event.eventType) {
      const fieldChangedEvent = event as LMInvalidFieldEvent;
      fieldChangedEvent.alert.scrollIntoView(false);
    }

    this.fieldEvent.emit(event);
  }

  ngOnInit() { }

  ngAfterViewInit() {
    this.lmLoggerService.log([ this, this.instanceId, 'ngAfterViewInit' ]);
    if (this.hideBusyIndicator) {
      this.lmBusyIndicatorService.hideBusyIndicator();
    }
  }

  ngOnDestroy() {
    // if (this.routerEventsSubscription) {
    //   this.routerEventsSubscription.unsubscribe();
    // }
  }

  //   /***********************************************
  //    * PUBLIC METHODS
  //    ***********************************************/

  public getComponentInfo(additionalInfo?: LMCompInfoAdditionalInfo): LMComponentInfo {
    const pagingUrls: LMFormPagingUrls = (this.model) ? this.model.getPagingUrls() : undefined;
    const isContextForm = (this.formSpec.busFormSpec && this.formSpec.isContextForm) || !this.formSpec.busFormSpec;
    let resourceInfo = (this.formSpec && this.formSpec.resourceInfo) ? this.formSpec.resourceInfo : undefined;
    resourceInfo = (!resourceInfo && this.formSpec && this.formSpec.busFormSpec && this.formSpec.busFormSpec.resourceInfo) ? this.formSpec.busFormSpec.resourceInfo : undefined;

    let formInfo: LMComponentInfo;

    if (isContextForm) {

      const lmBusFormSpec: LMBusFormSpec = this.formSpec.busFormSpec ? this.formSpec.busFormSpec : this.buildBusFormSpec(this.formSpec);
      const compConfigInfo = {};
      compConfigInfo['configuration'] = this.formSpec ? this.formSpec.configuration : undefined;
      compConfigInfo['personalization'] = this.formSpec ? this.formSpec.personalization : undefined;
      compConfigInfo['configStamp'] = this.formSpec ? this.formSpec.configStamp : undefined;
      compConfigInfo['classConfigStamp'] = this.formSpec ? this.formSpec.classConfigStamp : undefined;

      formInfo = {
        componentType: 'CONTEXT_FORM',
        name: this.formSpec ? lmBusFormSpec.name : undefined,
        contextFormSpec: lmBusFormSpec  ? lmBusFormSpec : undefined,
        type: this.formSpec ? lmBusFormSpec.formType : 'Standard',
        configInfo: compConfigInfo,
        lpl: this.formSpec ? lmBusFormSpec.lpl : undefined,
        resourceInfo,
        hasConfigAccess: this.lmComponentInfoService.hasConfigAccess(),
      };

      if (pagingUrls) {
        formInfo.nextRecordUrl = pagingUrls.nextRecordUrl;
        formInfo.previousRecordUrl = pagingUrls.previousRecordUrl;
        formInfo.reloadRecordUrl = pagingUrls.reloadRecordUrl;
      }
    }
    return formInfo;
  }

  // this is passed in as an any since we have defined the input as a LMFormSpec but sometimes we pass a LMBusFormSpec.
  // The input accepts the improper type without error but trying to access values throws compile errors.
  private buildBusFormSpec(formSpec: any): LMBusFormSpec {
    const lmBusFormSpec: LMBusFormSpec = {
      name: formSpec.name,
      //  type: formSpec.formType,
      configuration: formSpec.configuration,
      personalization: formSpec.personalization,
      configStamp: formSpec.configStamp,
      classConfigStamp: formSpec.classConfigStamp,

      lpl: formSpec.lpl
    };
    return lmBusFormSpec;
  }

  public isModified(): boolean {
    return this.model.isDirty;
  }

  runRefresh() {
    // NOTHING TO REFRESH OUTSIDE THE DATAVIEW
  }

  runSaveAction(): Observable<boolean> {

    return new Observable<boolean>(observer => {
      if (this.model.hasManualRepFileds) {
        const refs: LMManualRepresentationComponent[] = this.lmHtmlUrlDocService.getManualRefCompRefs();
        this.lmGlobalUtilService.runSaveManualReps(observer, refs);
      } else {
        // NOTHING TO SAVE OUTSIDE OF THE DATAVIEW
        observer.next(true);
        observer.complete();
      }
    });
  }

  saveComponentState(): void {
    // noop
  }

  clearComponentState(): void {
    // noop
  }

  handleBlockingErrorField(event: LMInvalidFieldEvent) {
    event.alert.scrollIntoView(false);
  }
}
